module.exports = __webpack_public_path__ + "img/lesson.637f19c0.jpg";